<template>
  <div>
    <!-- Post Type Selection Modal -->
    <modal
      class="post-type-modal"
      :name="'create-type-modal'"
      width="70%"
      height="auto"
      :clickToClose="false"
    >
      <v-container class="post-type-form">
        <div class="header">
          <h2 style="color: #00A9B3; margin: 0 0 16px 0">
            {{ $t('general.reflection.choice-title') }}
          </h2>
        </div>

        <div style="margin-bottom: 24px;">
          <v-radio-group v-model="postType">
            <v-radio 
              :label="$t('general.reflection.choice-post')" 
              value="post"
              color="#00A9B3"
            ></v-radio>
            <v-radio 
              :label="$t('general.reflection.choice-reflection')" 
              value="reflection"
              color="#00A9B3"
            ></v-radio>
          </v-radio-group>
        </div>

        <!-- Action buttons -->
        <div class="button-group" style="display: flex; gap: 12px; justify-content: center; margin-top: 24px;">
          <Button
            @click.native="closeChoiceModal"
            :title="$t('general.reflection.choice-cancel')"
            color="#e05484"
            bgcolor="#fff"
            style="border: 2px solid #e05484"
          />
          <Button
            @click.native="confirmChoice"
            :title="$t('general.reflection.choice-next')"
            bgcolor="#e05484"
            color="#fff"
          />
        </div>
      </v-container>
    </modal>
  </div>
</template>

<script>
import Button from "@/page_elements/Button";

export default {
  name: "SelectPostType",
  components: {
    Button
  },
  data() {
    return {
      postType: "post"
    };
  },
  methods: {
    confirmChoice() {
      this.$modal.hide('create-type-modal');
      this.$emit('type-selected', this.postType);
      
      if (this.postType === "reflection") {
        this.$modal.show('create-reflection-modal');
      }
    },
    closeChoiceModal() {
      this.$modal.hide('create-type-modal');
      this.postType = "post"; // Reset to default

      // Navigate back to the feed instead of staying on the post creation page
      if (this.$store.getters.user.role === "p") {
        window.location.href = "/";
      } else if (this.$store.getters.nurse) {
        window.location.href = `/dashboard/nurse/${this.$store.getters.nurse.id}/patient/${this.$store.getters.user.patient.id}`;
      } else {
        window.location.href = `/dashboard/nurse/${this.$store.getters.user.id}/patient/${this.$store.getters.user.patient.id}`;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.post-type-modal {
  .post-type-form {
    padding: 24px;
    max-width: 640px;
    margin: 0 auto;

    .header {
      margin-bottom: 20px;
    }

    .button-group {
      margin-top: 20px;
    }
  }
}

@media (max-width: 700px) {
  .post-type-modal {
    .post-type-form {
      max-width: 100%;
    }
  }
}
</style>
